export class TotalCompletesCalculator<
  T extends { completes_required: number }
> {
  constructor(private readonly _surveys: T[]) {}

  public calculate(): number {
    return this._surveys.reduce(
      (total: number, survey) => total + Number(survey.completes_required),
      0
    );
  }
}
